export class MapFloatHelper {
    constructor(getContainer, getFooter, getHeader, options = {}) {
        this.getContainer = getContainer;
        this.getFooter = getFooter;
        this.getHeader = getHeader;
        this.options = {
            minHeight: 250,
            padding: 15,
            ...options
        }
    }

    floatMainMap() {
        const container = this.getContainer();
        const footer = this.getFooter();
        const header = this.getHeader();

        if(!container) { return; }

        const leftWrapperResizeHandler = document.getElementsByClassName('ui-resizable-handle')[0];
        const leftWrapperResizeHandlerIndicator = document.getElementsByClassName('handle-indicators')[0];

        if(!leftWrapperResizeHandler) {
            container.style.left = '-14px';
            container.style.borderRightWidth = 0;
            container.style.top = '0px';
            let accordionHeaderActive = $('#left_wrapper > h2.ui-accordion-header-active');

            //let mapNotContentSize = (mapheight > 0 ? mapheight : 0) + $('#TopoMarker').height() + $('#overlayControls').height() + (accordionHeaderActive.count ? accordionHeaderActive.height() : 0);

            //let height = 600 -
            //    mapNotContentSize - 3 * mapPadding;

            //self.Canvas.style.height = height + 'px';

            return;
        }

        const windowHeight = window.innerHeight;
        const mapContainerBottom = footer ? footer.getBoundingClientRect().top : windowHeight;
        const mapContainerTop = header ? header.getBoundingClientRect().top : 0;

        // Platz für weitere Elemente falls nötig
        let mapHeader = document.getElementById('map_header');
        const extraSpace = mapHeader ?
            document.getElementById('map_header').getBoundingClientRect().height + document.getElementById('map_footer').getBoundingClientRect().height :
            0;

        // Maximale Höhe bestimmen

        const containerViewHeight = windowHeight - (mapContainerTop > 0 ? mapContainerTop : 0) - (mapContainerBottom < windowHeight ? windowHeight - mapContainerBottom : 0);
        const availableMapHeight = containerViewHeight - extraSpace;
        const deltaNegativTopValue =
            header.getBoundingClientRect().top < 0 ? availableMapHeight - this.options.minHeight : 0; // let min-height map scroll out of view

        //console.log(`hB: ${mapContainerTop} - fT: ${mapContainerBottom} - wH: ${windowHeight} - cVH: ${containerViewHeight} - mH: ${mapHeight} - eS: ${extraSpace}`);

        if((availableMapHeight) <= this.options.minHeight) {
            // Optional: Sticky-Plugin deaktivieren oder Map fix auf minHeight setzen
            container.style.top = deltaNegativTopValue + 'px';
            container.style.height = '100%';
            container.style.maxHeight = '100%';
        } else {
            container.style.height = containerViewHeight + 'px';
            container.style.maxHeight = containerViewHeight + 'px';
        }
        leftWrapperResizeHandler.style.top = (mapContainerTop > 0 ? mapContainerTop : 0) + 'px';
        leftWrapperResizeHandlerIndicator.style.top = (mapContainerTop > 0 ? mapContainerTop + 5 : 5) + 'px';
    }

    floatGalleryMap() {
        let windowHeight = window.innerHeight * 0.8;
        const galleryMapWrapper = document.getElementById('galleryMapWrapper');
        if (parseInt(galleryMapWrapper.style.height) < windowHeight) {
            document.getElementById('map_canvas').style.height = windowHeight + 'px';
        }
    }
}